import { __awaiter, __generator } from "tslib";
import { fetchSubEntities } from './http/fetch-sub-entitities';
import { SubEntityType } from './models/sub-entity-type';
export var fetchFamilyAttributes = function (familyId, includeType) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetchSubEntities(familyId, SubEntityType.Attributes, "f" /* Family */, includeType)];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };
